const state = {
	// 第一个玻片的答案
	detail1: [],
	detail3: [],
	// 第二个玻片的答案
	detail2: [],
	detail4: [],

	// 第一个玻片的id
	paper1Id: null,

	// 第二个玻片的id
	paper2Id: null,

	// 整套题
	slidePaper: sessionStorage.getItem('slidePaper'),

	// 选中的亮度
	num: 6,

	// 现在是第几个玻片  0是第一个  1是第二个
	slideType: 0,

	// 定时器
	microscopeModleTime: '',

	// 倒计时
	microscopeTimeNum: 3600,

	// 当前是哪个步骤  1代表显微镜  2代表诊疗思路
	activeIndex: 1,

	// 总暂停次数
	stateAllPauseCount: 2,

	// 当前暂停次数
	statePauseCount: 2,

	//试卷ID
	examDetailId: '',

	//是否暂停
	isPause: false,

}

const mutations = {
	handleMicroscope: (state, {
		key,
		value
	}) => {
		if (key === 'clear') {
			// 第一个玻片的答案
			state.detail1 = [],

				// 第二个玻片的答案
				state.detail2 = [],

				// 第一个玻片的id
				state.paper1Id = null,

				// 第二个玻片的id
				state.paper2Id = null,

				// 整套题
				state.slidePaper = null,

				// 选中的亮度
				state.num = 6,

				// 现在是第几个玻片  0是第一个  1是第二个
				state.slideType = 0,

				//定时器
				state.microscopeModleTime = '',

				//倒计时
				state.microscopeTimeNum = 3600,

				// 总暂停次数
				state.stateAllPauseCount = 2,

				// 当前暂停次数
				state.statePauseCount = 2,


				state.activeIndex = 1

			state.examDetailId = ''

			state.isPause = false
		} else if (state.hasOwnProperty(key)) {
			if (key === 'clear') {
				// 第一个玻片的答案
				state.detail1 = [],

					// 第二个玻片的答案
					state.detail2 = [],

					// 第一个玻片的id
					state.paper1Id = null,

					// 第二个玻片的id
					state.paper2Id = null,

					// 整套题
					state.slidePaper = null,

					// 选中的亮度
					state.num = 6,

					// 现在是第几个玻片  0是第一个  1是第二个
					state.slideType = 0,

					//定时器
					state.microscopeModleTime = '',

					//倒计时
					state.microscopeTimeNum = 3600,

					state.activeIndex = 1,

					// 总暂停次数
					state.stateAllPauseCount = 2,

					// 当前暂停次数
					state.statePauseCount = 2

				state.examDetailId = ''
				state.isPause = false
			} else if (key === 'detail1' || key === 'detail2') {
				state[key].push(value)
			} else if (key === 'detail3' || key === 'detail4') {
				if (key === 'detail3') {
					state['detail1'] = value
				} else {
					state['detail2'] = value
				}
			} else {
				state[key] = value
			}
			sessionStorage.setItem(key, JSON.stringify(state[key]))

		}
	}
}
const actions = {

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}